"use client";

import React from "react";
import { Loader, Paperclip } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SupportInquiry() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}
function SupportForm() {
  const {
    isSubmitting,
    handleSubmit,
    control
  } = useWvcForm();
  const inputClasses = "border-0 border-b-2 border-muted/50 p-3 transition-all duration-300 focus-visible:border-primary focus-visible:ring-0 rounded-none bg-transparent font-mono text-foreground placeholder:text-muted-foreground/30";
  const labelClasses = "font-mono text-[12px] font-bold text-primary tracking-widest uppercase";
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <FormField control={control} name="name" rules={{
      required: "Operator identity required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>CMD&gt; OPERATOR_ID</FormLabel>
            <FormControl>
              <Input placeholder="AUTHORIZED_PERSONNEL" {...field} className={inputClasses} />
            </FormControl>
            <FormDescription className="font-mono text-[10px] opacity-50 uppercase">
              Identify yourself for the secure transmission log.
            </FormDescription>
            <FormMessage className="font-mono text-[10px]" />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Communication node required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid node address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>CMD&gt; COMM_CHANNEL</FormLabel>
            <FormControl>
              <Input type="email" placeholder="NODE@ENCRYPTED.NET" {...field} className={inputClasses} />
            </FormControl>
            <FormDescription className="font-mono text-[10px] opacity-50 uppercase">
              Encrypted return frequency for response data.
            </FormDescription>
            <FormMessage className="font-mono text-[10px]" />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>CMD&gt; SIGNAL_TAG</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+1-000-POSEIDON" {...field} className={inputClasses} />
            </FormControl>
            <FormDescription className="font-mono text-[10px] opacity-50 uppercase">
              Optional - Emergency audio link frequency.
            </FormDescription>
            <FormMessage className="font-mono text-[10px]" />
          </FormItem>} />

      <FormField control={control} name="subject" rules={{
      required: "Objective required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>CMD&gt; MISSION_OBJECTIVE</FormLabel>
            <FormControl>
              <Input placeholder="QUERY_TYPE_ALPHA" {...field} className={inputClasses} />
            </FormControl>
            <FormDescription className="font-mono text-[10px] opacity-50 uppercase">
              Classify the nature of your transmission.
            </FormDescription>
            <FormMessage className="font-mono text-[10px]" />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Content required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClasses}>CMD&gt; TRANSMISSION_CONTENT</FormLabel>
            <FormControl>
              <Textarea placeholder="INPUT SECURE DATA STREAM HERE..." {...field} className={`${inputClasses} min-h-[120px]`} />
            </FormControl>
            <FormDescription className="font-mono text-[10px] opacity-50 uppercase">
              Detailed intelligence for the Poseidon Directive.
            </FormDescription>
            <FormMessage className="font-mono text-[10px]" />
          </FormItem>} />

      <FormField control={control} name="attachment" render={({
      field: {
        value,
        onChange,
        ...fieldProps
      }
    }) => <FormItem>
            <FormLabel className={labelClasses}>
              CMD&gt; UPLOAD_INTEL
            </FormLabel>
            <FormControl>
              <div className="relative">
                <Input {...fieldProps} type="file" className={`${inputClasses} file:text-primary file:font-mono file:bg-transparent file:border-0 file:mr-4 pt-2`} onChange={event => {
            onChange(event.target.files && event.target.files[0]);
          }} />
                <Paperclip className="text-primary/50 pointer-events-none absolute top-3 right-3 size-4" />
              </div>
            </FormControl>
            <FormDescription className="font-mono text-[10px] opacity-50 uppercase">
              Attach visual evidence or classified documents.
            </FormDescription>
            <FormMessage className="font-mono text-[10px]" />
          </FormItem>} />

      <Button type="submit" disabled={isSubmitting} className="bg-transparent border-2 border-primary hover:bg-primary hover:text-background font-sans w-full py-6 text-lg font-bold text-primary transition-all rounded-none uppercase tracking-widest shadow-[0_0_15px_rgba(0,255,255,0.2)]">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            UPLOADING...
          </> : "EXECUTE COMMAND"}
      </Button>
    </Form>;
}